import axios from 'axios'

export default axios.create({
  baseURL: 'https://www.yscdsj.com/api',
  timeout: 5000,
});